import { getStartCase } from 'src/utils';
import navigator from './navigator';

export const Tenants = {
  ADMIN: 'admin',
  FIS: 'fis',
};

const TenantOptions = Object.values(Tenants).map((value) => ({
  label: value === Tenants.FIS ? value.toUpperCase() : getStartCase(value),
  isHideOnProduction: false,
  value,
}));

const DefaultTenant = Tenants.FIS;

type Tenant = {
  name: string;
};

let _tenant: Tenant = {
  name: '',
};

const setTenant = (tenant?: Tenant) => {
  if (tenant) return (_tenant = tenant);
};

const getTenant = () => _tenant;

const getWebTenant = () => {
  const subDomain = navigator.getSubdomain();
  const isHasSubdomain = Object.values(Tenants).some((item) => item === subDomain);
  const validSubdomain = isHasSubdomain ? subDomain : DefaultTenant;
  return validSubdomain;
};

const changeWebTenant = (tenant: string) => {
  const validSubdomain = getWebTenant();
  if (tenant !== validSubdomain) {
    const nextDomain = tenant === DefaultTenant ? '' : tenant;
    return navigator.jumpToCrossDomain(nextDomain);
  }
};

// ================== Check tenant ==================
const isAdmin = () => _tenant?.name === Tenants.ADMIN;
const isFIS = () => _tenant?.name === Tenants.FIS;

export {
  DefaultTenant,
  TenantOptions,
  changeWebTenant,
  getTenant,
  getWebTenant,
  isAdmin,
  isFIS,
  setTenant,
};
